var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ position: _vm.position, height: (_vm.height + "px") }),attrs:{"id":"solidBackground"}},[_c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"}],style:({
        transform: ("rotate(" + _vm.rotate + "deg)"),
        top: (_vm.top + "vh"),
        left: ("-" + _vm.left + "%"),
        height: (_vm.height + "px"),
        transitionDuration: ((_vm.animTime.present) + "s"),
      })})])}
var staticRenderFns = []

export { render, staticRenderFns }